import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';

import { NamedEntity } from '../../../../types';

interface NamedEntityListProps {
  items: NamedEntity[] | null;
}

export const NamedEntityList = ({ items }: NamedEntityListProps) => {
  if (!items || !items.length) return <Typography color="error">No data</Typography>;

  return (
    <Stack gap="0.5rem">
      {items.map(item => (
        <Chip key={item.id} label={<Typography>{item.name}</Typography>} size="small" variant="outlined" color="info" />
      ))}
    </Stack>
  );
};
